import React, { useEffect, useRef, useImperativeHandle } from "react";
import { Colors } from "utils/imports.utils";
import "./progress_bar.ui.scss";

interface IProgressBar {
  value: number;
  max: number;
  text:string;
}

const ProgressBar = (props: IProgressBar) => {
  // Redux

  // State

  //Hooks

  // Network req

  //Logic

  return (
    <>
      <div className="progress_bar_component">
        <div className="progress_bar_container">
          <div className="progress_bar_header">
            <div className="progress_bar_header_text">{props.text}</div>
            <div className="progress_bar_header_count">
              {Math.round((props.value / props.max) * 100)}%
              {(() => {
                // console.log(`${(props.value / (1024 * 1024)).toFixed(1)} MB / ${(props.max / (1024 * 1024)).toFixed(1)} MB`);
                return null;
              })()}
            </div>
          </div>
          <div className="progress_bar_body">
            <div
              className="progress_bar_wrapper"
              style={{
                backgroundImage:Colors.primaryGradient,
                // backgroundColor: Colors.primaryColor, // Green color for the progress
                height: "100%", // Set the height to fill the entire bar
                borderRadius: "10px", // Match the parent's border-radius
                width: `${(props.value / props.max) * 100}%`, // Calculate the progress width
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
